const regexHelper = {
  uri(path: string) {
    return /^(.*:)\/\/([A-Za-z0-9\-\.]+)(:[0-9]+)?(.*)$/.test(path)
  },
}

export default regexHelper
